import React from 'react';
import { Space, ConfigProvider } from 'antd';
import useDefaultTrebbleAntDTokenConfig from '../helper/useDefaultTrebbleAntDTokenConfig';

type SpaceSize = 'small' | 'middle' | 'large' | number;

interface TrebbleSpaceProps {
  align?: 'start' | 'end' | 'center' | 'baseline';
  direction?: 'horizontal' | 'vertical';
  size?: SpaceSize | [SpaceSize, SpaceSize];
  split?: React.ReactNode;
  wrap?: boolean;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const TrebbleSpace: React.FC<TrebbleSpaceProps> = ({
  align,
  direction = 'horizontal',
  size = 'small',
  split,
  wrap,
  className = '',
  style,
  children,
  ...props
}) => {
  const tokenConfig = useDefaultTrebbleAntDTokenConfig();
  
  const combinedClassName = `trebble-space ${className}`;
  
  return (
    <ConfigProvider theme={tokenConfig}>
      <Space
        align={align}
        direction={direction}
        size={size}
        split={split}
        wrap={wrap}
        className={combinedClassName}
        style={style}
        {...props}
      >
        {children}
      </Space>
    </ConfigProvider>
  );
};

export default TrebbleSpace; 